export const enabledRoutes = [
  '/buy-travel-insurance',
  '/buy-multitrip-insurance',
  '/buy-foreigners-insurance',
  '/buy-accident-insurance'
]